export default __webpack_public_path__ + "static/media/arrow_left-icon.1e2f96cf.svg";